/// <amd-module name="Wit/WorkItemForm/Links/GitHub/GitHubDataProviderContracts" />

export interface GitHubLinkItemsRequest {
    identifiers?: ExternalLinkedArtifactIdentifier[];
    urls: string[];
    workItemId: number;
}
export interface GitHubLinkItemsResponse {
    resolvedLinkItems: ExternalLinkedArtifact[];
}
export interface ExternalLinkedPullRequestArtifact extends ExternalLinkedArtifact {
    /**
     * Pull request's target branch name
     */
    target: string;
    /**
     * Identifies if the pull request is a draft
     */
    isDraft: boolean;
    /**
     * State of review decision for the Pull Request
     */
    reviewDecision: string;
    /**
     * The time and date when the PR was created
     */
    createdAt?: Date;
    /**
     * The time and date when the pull request was merged
     */
    mergedAt?: Date;
    /**
     * The time and date when the pull request was closed
     */
    closedAt?: Date;
    /**
     * Check and Status rollup information for the PR
     */
    checkResults?: ExternalCheckResult[];
}
export interface ExternalLinkedArtifact extends ExternalLinkedArtifactIdentifier {
    author: Author;
    /**
     * GitHub connection auth type. (e.g. Installation, Oauth)
     */
    connectionAuthenticationType: string;
    date: Date;
    /**
     * Error message indicating what went wrong when trying to parse/retrieve link
     */
    errorMessage: string;
    /**
     * GitHub provider key. (e.g. github.com)
     */
    providerKey: string;
    /**
     * GitHub item repository name with owner
     */
    repoNameWithOwner: string;
    state: string;
    title: string;
    /**
     * GitHub item web url
     */
    url: string;
}
export interface ExternalLinkedArtifactIdentifier {
    /**
     * GitHub item type. (e.g. Pull, Issue or Commit)
     */
    itemType: ExternalArtifactType;
    /**
     * GitHub item number (PR or Issue) or SHA (Commit)
     */
    numberOrSHA: string;
    /**
     * GitHub item internal repository Guid
     */
    repoInternalId: string;
}
export enum ExternalArtifactType {
    Unknown = 0,
    PullRequest = 1,
    Commit = 2,
    Issue = 3
}
export interface Author {
    avatarUrl: string;
    displayName: string;
}
export interface DevelopmentZeroDataSettingsResponse {
    showAzureReposZeroDataExperience: boolean;
    showGitHubPromoteZeroDataExperience: boolean;
    showGitHubZeroDataExperience: boolean;
}
export interface GitHubRateLimit {
    limit: number;
    remaining: number;
}
export interface GitHubPaginatedRequest {
    pageSize: number;
    filter?: string;
    continuationToken?: string;
    repositoryName?: string;
    repositoryExternalId?: string;
}
export interface GitHubPaginatedResponse<T> {
    continuationToken?: string;
    rateLimit?: GitHubRateLimit;
    data: T[];
}
export interface ExternalCheckResult {
    name: string;
    workflowName: string;
    startedAt?: Date;
    completedAt?: Date;
    status?: string;
    conclusion?: string;
}
